Ext.define('SA.MessageWindowManager', {
    statics: {
        initialize() {
            var manager = new SA.MessageWindowManager();

            SA.msg = msg => manager.showMessage(msg);
            SA.warn = msg => manager.showMessage({msg, duration: 10000});
            SA.error = msg => manager.showError(msg);
        }
    },

    constructor() {
        this.messageWindows = [];
        this.errorDuration = 15000;
    },

    showError(msg) {
        this.showMessage({
            duration: this.errorDuration,
            msg: msg + '\n\n' + new Date().toUTCString(),
            ui: 'error'
        });

        if (this.errorDuration > 5000) {
            this.errorDuration -= 2000;
        }
    },

    showMessage(msg) {
        if (typeof msg === 'string') {
            msg = {msg};
        }

        var windows = this.messageWindows,
            win = Ext.create('SA.view.MessageWindow', msg);

        win.fadeInAtBottom(getBottom());

        win.on('destroy', () => Ext.Array.remove(windows, win));

        windows.push(win);

        function getBottom() {
            var priorWin = windows[windows.length - 1],
                priorWinTop = priorWin && priorWin.getY();

            return priorWinTop || Ext.getBody().getHeight();
        }
    }
});
